<template>
    <div class="tips" ref="appOpen" v-show="showTips" @click="toLink">
        <div class="topTips clearfix topTipsDown">
        <span class="homeIcon" style="background-image:url('https://img2.hebnews.cn/img/home.53fe0d7.png');background-size:100%;"></span> 
        <i class="rightLine"></i> <span class="slogon">纵览新闻</span> <span class="openApp" id="appOpenCodeUrl">下载</span></div>
    </div>
</template>

<script>

import jump2zonglan from '@/utils/jump2app-zonglan.js'

export default {
  name:'tips',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
        showTips:true,
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted() {
    let openinstall = document.createElement('script');
    openinstall.async = "async";
    openinstall.src = 'https://web.cdn.openinstall.io/openinstall.js';
    openinstall.onload = () => {
      console.log('openinstall.js loaded and ready to use!');
      this.checkTips()
    };
    document.head.appendChild(openinstall); 

  },
  methods: {
    checkTips() {
        if (/(zonglan6756)/i.test(navigator.userAgent)) {
            this.showTips = false;
            console.log('00');
        } else {
            console.log('11');
            this.showTips = true;
        }
    },
    toLink() {
      console.log('toMLink');
        jump2zonglan.toMLink()
    },
    clickOpen(){
      console.log('appOpen');
      this.$refs.appOpen.click();
    },
    closeTips() {
        this.showTips = false;
    }
  },
}
</script>
<style scoped>

/* 纵览客户端顶部下载提示样式 */
.tips{ background:#fff;z-index:100}
.tips,.tips .bankBlock,.tips .topTips{width:750px;height:100px;max-width:750px}
.tips .topTips{max-width:750px;position:fixed;top:0;background:#fff;z-index:100;border-top:2px solid #f5f5f5;border-bottom:.2px solid #f5f5f5}
.tips .topTips .homeIcon{float:left;display:inline-block;width:80px;height:80px;background-position:50%;background-repeat:no-repeat;margin:10px 25px}
.tips .topTips .rightLine{display:inline-block;height:50px; margin: 25px 1px; background:#f5f5f5;float:left}
.tips .topTips .slogon{float:left;color:#9e9e9e;font-size:28px; height: 40px; line-height: 40px; display: inline-block; margin: 30px 0px;}
.tips .topTips .openApp{float:right;margin: 25px;display:flex;width: 120px; height: 50px;border-radius: 30px;background:#e51c23;color:#fff;font-size: 28px;text-align:center;justify-content:center;align-items:center;}
.tips .topTipsUp{top:-138px;}
.tips .topTipsDown{top:0}
</style>
